<template>
  <div id="app" :class="$route.name">
    <nav class="contact">
      <a href="//github.com/mastastealth">Github</a>
      <a href="mailto:hi@brianfran.co?subject=Hi Brian...">E-mail</a>
    </nav>

    <NavBar />
    
    <transition name="fade">
      <router-view/>
    </transition>

    <footer>All rights reserved &copy; Copyright {{new Date().getFullYear()}}.</footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: "app",
  components: {
    NavBar
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Segoe UI";
  font-weight: 200;
  src: local("Segoe UI Light");
}
@font-face {
  font-family: "Segoe UI";
  font-weight: 300;
  src: local("Segoe UI Semilight");
}
@font-face {
  font-family: "Segoe UI";
  font-weight: 400;
  src: local("Segoe UI");
}
@font-face {
  font-family: "Segoe UI";
  font-weight: 600;
  src: local("Segoe UI Semibold");
}
@font-face {
  font-family: "Segoe UI";
  font-weight: 700;
  src: local("Segoe UI Bold");
}
@font-face {
  font-family: "Segoe UI";
  font-style: italic;
  font-weight: 400;
  src: local("Segoe UI Italic");
}
@font-face {
  font-family: "Segoe UI";
  font-style: italic;
  font-weight: 700;
  src: local("Segoe UI Bold Italic");
}

* {
  box-sizing: border-box;
}

html,
body {
  font-family: "Segoe UI", "Avenir", Helvetica, Arial, sans-serif;
  height: 100%;
  margin: 0;
  padding: 0;
}

h1,
h2,
h3 {
  font-weight: 300;

  small {
    font-size: 0.5em;
    margin-left: 10px;
    opacity: 0.5;
  }
}

a {
  color: #18a4b9;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

article {
  font-size: 18px;
  line-height: 160%;
  max-height: 50%;
  min-height: 640px;
  padding: 10px;
  z-index: 1;

  img {
    border: 1px solid rgba(0, 0, 0, 0.3);
    display: block;
  }

  @supports (animation-fill-mode: forwards) {
    animation: fadeUp 0.5s ease-in;
    animation-fill-mode: forwards;
    opacity: 0;
  }
}

#app {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  height: 100vh;
  justify-content: center;
  overflow: hidden;
  transition: background 0.3s;

  &.develops {
    background: #99cc66;
  }
  &.designs {
    background: #333333;
  }
  &.draws {
    background: #18a4b9;
  }
  &.authors,
  &.wroteabook {
    background: #ffa500;
  }

  > .main-nav {
    background: white;
    padding: 5px 0;
    position: fixed;
    top: 0;
    left: 0;
    transition: transform 0.5s, opacity 0.5s;
    width: 100%;
    z-index: 2;
  }

  &.home > .main-nav {
    opacity: 0;
    transform: translateY(-100%);
    pointer-events: none;
    z-index: -1;
  }

  > footer {
    mix-blend-mode: overlay;
    line-height: 48px;
    opacity: 0.9;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    width: 100%;
  }
}

.page {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 10px;
  height: 100vh;
  margin: 0 auto;
  overflow: auto;
  padding: 110px 50px 50px;
  width: 100%;

  img {
    max-width: 100%;
  }

  &:after {
    content: "";
    display: block;
    grid-column-start: 1;
    grid-column-end: 4;
    height: 50px;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;

    &:after {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }

  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
    padding: 100px 10px 40px;

    &:after {
      grid-column-start: 1;
      grid-column-end: 2;
      height: 100px;
    }
  }
}

.fade-leave-active {
  transition: transform 0.25s ease-in, opacity 0.25s;
}

.fade-enter-active {
  transition: transform 0.25s ease-in, opacity 0.25s;
  transition-delay: 0.3s, 0.3s;
}

.fade-leave {
  position: fixed;
}

.fade-leave-to {
  opacity: 0;
  position: fixed;
  transform: translateY(-50px);
}

.fade-enter {
  opacity: 0;
  transform: translateY(50px);
}

.fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.contact {
  line-height: 60px;
  position: fixed;
  top: 0;
  right: 10px;
  z-index: 3;

  a {
    margin: 0 10px;
  }

  @media screen and (max-width: 700px) {
    display: flex;
    top: auto;
    bottom: 40px;
    text-align: center;
    width: 100%;
    z-index: 0;

    a {
      width: 50%;
    }
  }
}
</style>
